
import { Action } from '@ngrx/store';

export const ADD_LOGGED_IN_DETAIL = '[LOGGEDINDETAIL] Add';
export const REMOVE_LOGGED_IN_DETAIL = '[LOGGEDINDETAIL] Remove';

// AddPersonalDetails
export class AddLoggedInDetail implements Action {
    readonly type = ADD_LOGGED_IN_DETAIL;

    constructor(public payload: any) { }
}
// RemovePersonalDetails
export class RemoveLoggedInDetail implements Action {
    readonly type = REMOVE_LOGGED_IN_DETAIL;

    constructor(public payload: number) { }
}

export type Actions = AddLoggedInDetail | RemoveLoggedInDetail;
